import classnames from 'classnames'

function isValidNumber(value) {
  return /^[0-9]*\.?[0-9]{0,2}$/.test(value)
}

function safeToLocaleString(value) {
  if (!value) return ''
  if (String(value).endsWith('.')) return `${Number(value).toLocaleString()}.`
  return Number(value).toLocaleString()
}

export default function PriceFormField({ error, value = '', adornment, onChange, ...inputProps }) {
  const handleChange = (event) => {
    event.persist()
    event.target.value = event.target.value.replace(/,/g, '')
    if (!isValidNumber(event.target.value)) return
    onChange(event)
  }

  return (
    <div
      className={classnames(
        'inputContainer flex alignCenter justifyBetween',
        { error },
        inputProps.className,
      )}
    >
      <input
        inputMode='numeric'
        onChange={handleChange}
        value={safeToLocaleString(value)}
        {...inputProps}
      />
      {!!adornment && <div className='adornment'>{adornment}</div>}

      <style jsx>{`
        .inputContainer {
          position: relative;
          height: 4.2rem;
          border-radius: 2.1rem;
          background: #fff;

          &::before {
            content: '$';
            position: absolute;
            left: 1.9rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 1.6rem;
          }

          input {
            width: 100%;
            height: 100%;
            padding: 0 1.9rem 0 2.8rem;
            border-radius: inherit;
            outline: none;
            background: transparent;
            border: 0.2rem solid var(--secondary-input-bg);
            font-size: 1.6rem;
            transition: border-color 0.2s;

            &:focus {
              border-color: var(--primary-color);
            }

            &::placeholder {
              color: var(--secondary-text-color);
            }
          }

          &.error {
            input {
              border-color: var(--alert-color);
            }
          }

          .adornment {
            position: absolute;
            top: 50%;
            right: 1.9rem;
            transform: translate(0, -50%);
          }
        }

        @media (max-width: 1024px) {
          .inputContainer {
            height: 3.5rem;
            border-radius: 1.8rem;

            input {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
